export default __webpack_public_path__ + "static/media/app-store-apple.8a7fd273.png";